export const formSubmmitMapper = (data) => ({
  kode_kelompok_anggaran: data?.kodeKelompok,
  id_kelompok_anggaran: data?.idKelompok,
  nama_kelompok_anggaran: data?.namaKelompok,
  id_jenis_anggaran: data?.idJenis,
  keterangan: data?.keterangan,
});
